import React from 'react';
import {createFragmentContainer, graphql} from 'react-relay';
import Util from '../../forecast-app/shared/util/util';
import Phase from './Phase';
import {PhasesWrapper, FlexRow, PhasesTitle, ColumnTitleItem} from './InitialPlan.styled';
import {initExpandedPhasedLocalStorage, getTooltipForHeader} from './InitialPlanUtil';
import EmptyState from '../../forecast-app/shared/components/empty-states/empty_state';
import ForecastTooltip from '../../forecast-app/shared/components/tooltips/ForecastTooltip';

export const PhasesSection = ({project, intl, roles, expenseCategories, phaseSortOrder, phases, currencySymbol, enabledColumns, theEyeOptions, useThirdLevel, toggleCollapseAll}) => {
	const projectStartDate = Util.CreateNonUtcMomentDate(project.projectStartYear, project.projectStartMonth, project.projectStartDay);
	const projectEndDate = Util.CreateNonUtcMomentDate(project.projectEndYear, project.projectEndMonth, project.projectEndDay);

	const sortedPhases = phases.sort((a, b) => phaseSortOrder.indexOf(a.node.id) - phaseSortOrder.indexOf(b.node.id));

	let expandMap = initExpandedPhasedLocalStorage(project.id, sortedPhases);
	const enabledColumnEntries = Object.entries(enabledColumns);

	const getElemProps = value => {
		return theEyeOptions[value - 1];
	};

	const getElemForHeaderColTitle = (column, value, index) => {
		if (!value) return null;
		const elemProps = getElemProps(value);

		const columnTitle = (
			<ColumnTitleItem key={`header-${column}-title`} align={elemProps.align} width={elemProps.width} paddingLeft={elemProps.leftOffset}>
				<ForecastTooltip maxWidth="none" placement={'left'} content={getTooltipForHeader(column, intl.formatMessage)}>
					{intl.formatMessage({id: elemProps.translationIdPhaseHeader || elemProps.translationId})}
				</ForecastTooltip>
			</ColumnTitleItem>
		);
		return columnTitle;
	};

	return (
		<FlexRow grow>
			<PhasesWrapper data-cy={'baseline-phases'}>
				<PhasesTitle thirdLevel={useThirdLevel}>
					<ColumnTitleItem width={150} growable></ColumnTitleItem>
					{enabledColumnEntries.map(([col, val], index) => getElemForHeaderColTitle(col, val, index))}
					<ColumnTitleItem width={55}></ColumnTitleItem>
					<ColumnTitleItem width={20}></ColumnTitleItem>
				</PhasesTitle>
				{sortedPhases.length > 0 ? (
					sortedPhases.map(phase => {
						return (
							<Phase
								theEyeOptions={theEyeOptions}
								key={phase.node.id}
								intl={intl}
								phase={phase.node}
								projectId={project.id}
								project={project}
								projectStartDate={projectStartDate}
								projectEndDate={projectEndDate}
								projectColor={project.projectColor}
								roles={roles}
								expenseCategories={expenseCategories}
								currencySymbol={currencySymbol}
								enabledColumnEntries={enabledColumnEntries}
								isCollapsed={expandMap.get(phase.node.id)}
								toggleCollapseAll={toggleCollapseAll}
								useThirdLevel={useThirdLevel}
							/>
						);
					})
				) : (
					<EmptyState pageName={EmptyState.EMPTY_STATE.BASELINE}></EmptyState>
				)}
			</PhasesWrapper>
		</FlexRow>
	);
};

export default createFragmentContainer(PhasesSection, {
	phases: graphql`
		fragment PhasesSection_phases on PhaseTypeEdge @relay(plural: true) {
			node {
				id
				...Phase_phase
				startYear
				startMonth
				startDay
				deadlineYear
				deadlineMonth
				deadlineDay
			}
		}
	`,
});
